var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{attrs:{"label":`I am willing to relocate nationally`,"color":_vm.themes.candidate.light.input},on:{"change":_vm.submit},model:{value:(_vm.profile.willingToRelocateNationally),callback:function ($$v) {_vm.$set(_vm.profile, "willingToRelocateNationally", $$v)},expression:"profile.willingToRelocateNationally"}})
}
var staticRenderFns = []

export { render, staticRenderFns }